import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

// Images imported from assets
import TijoreeFooterLogo from '../assets/img/logo-white.svg';
import EmailIcon from '../assets/img/ic_round-email.svg';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const ScrollUp = () => {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return (
    <footer>
      <div className="container-md">
        <div className="row">
          <div className="col-md-12 home-footer">
            <Link to={'/'}>Home</Link>
            <div className="footer-divider logo">
              <div className="logo"><img src={TijoreeFooterLogo} alt="tijoree" /></div>
            </div>
          </div>
          <div className="col-md-3">
            <h4>Product</h4>
            <ul>
              <li>
                <Link to={'/products/current-account'} onClick={ScrollUp}>Current Accounts</Link>
              </li>
              <li>
                <button className="ccbtn" onClick={() => {
                  navigate("/", {
                    state: { id: 'business-cc' },
                  });
                }}>
                  Corporate Credit Cards
                </button>
              </li>
              <li>
                <Link to={'/products/payment-collection'} onClick={ScrollUp}>Payment Collection Reminders</Link>
              </li>
              <li>
                <Link to={'/products/pos'} onClick={ScrollUp}>POS & Payment Gateway</Link>
              </li>

              <li>
                <a href='https://loan.tijoree.money/' target='_blank' rel="noreferrer">Apply for a Loan</a>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to={'/faq'} onClick={ScrollUp}>FAQs</Link>
              </li>
              <li>
                <Link to={'/blog'} onClick={ScrollUp}>Blog</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to={'/about'} onClick={ScrollUp}>About Us</Link>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/tijoree-money/" target="_blank" rel="noreferrer">Careers</a>
              </li>
              <li>
                <Link to={'/form'} onClick={ScrollUp}>Contact</Link>
              </li>
              {/* <li>
                <Link to={'/privacy-policy'}>Privacy Policy</Link>
              </li>
              <li>
                <Link to={'/terms-conditions'}>Terms & Conditions</Link>
              </li> */}
            </ul>
          </div>
          <div className="col-md-3">
            <h4>Follow Us</h4>
            <ul>
              <li className="linkedin">
                <a href="https://www.linkedin.com/company/tijoree-money/" target="_blank" rel="noreferrer">Linkedin</a>
              </li>
              <li className="twitter">
                <a href="https://twitter.com/tijoreemoney?s=21&t=VptfLfGqMLEGgAb0E-u9zw" target="_blank" rel="noreferrer">X (formerly Twitter)</a>
              </li>
              <li className="youtube">
                <a href="https://www.youtube.com/@tijoreemoney" target="_blank" rel="noreferrer">Youtube</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-divider"></div>
        <div className="row">
          <div className="col-md-5 col-lg-6">
            <div className="inner-items">
              <ul>
                <li>
                  <Link to={'/terms-conditions'}>Terms & Conditions</Link>
                </li>
                <li>
                  <Link to={'/privacy-policy'}>Privacy Policy</Link>
                </li>
                <li>
                  <Link to={'/refund-cancellation'}>Refund & Cancellation</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-5 col-lg-5">
            <a className="d-flex justify-content-lg-end text-light" href='mailto:support@tijoree.money'>
              <img src={EmailIcon} alt="Email" />&nbsp;support@tijoree.money
            </a>
          </div>
          <div className="col-md-2 col-lg-1">
            <div className="locations">
              <ul className="d-flex justify-content-lg-end">
                <li className="india">India</li>
              </ul>
            </div>
          </div>
          <div className="col-md-12">
            <div className="copyright">
              &copy; Tijoree 2023 Copyrights and All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
